export class Navigation {
  id!:string
  name!:string
  icon!:string
}
